import { useRouter } from "next/router";
import React, { useCallback, useMemo } from "react";
import useSWRInfinite from "swr/infinite";

interface IUseViewMoreFetching {
  initialItems: JSX.Element[];
  itemsDisplayedAmount: number;
  total: number;
  cardBuilder: any;
  setShowViewMore: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IUseViewMoreFetchingResult {
  cardsToDisplay: JSX.Element[];
  onClickHandler: () => void;
}

const useViewMoreFetching = ({
  initialItems,
  itemsDisplayedAmount,
  cardBuilder,
  setShowViewMore,
}: IUseViewMoreFetching): IUseViewMoreFetchingResult => {
  const router = useRouter();

  const key = (index: number): string | null => {
    const query = new URLSearchParams({
      url: Array.isArray(router?.query?.slug)
        ? router?.query?.slug.join("@")
        : "",
      currentItems: (index * itemsDisplayedAmount).toString(),
      next: itemsDisplayedAmount.toString(),
    });
    return `/api/landing-pages/get-items/?${query}`;
  };
  const fetcher = async (key: string): Promise<JSX.Element[]> => {
    const apiCall = await fetch(key);
    const response = await apiCall.json();
    setShowViewMore(response?.hasMoreItems ?? false);
    return response?.items?.map((item: any) => {
      return cardBuilder(item);
    });
  };

  const { data, setSize } = useSWRInfinite(key, fetcher, {
    revalidateFirstPage: false,
  });

  const cardsToDisplay = useMemo(() => {
    return data?.flat() ?? initialItems;
  }, [data]);

  const onClickHandler = useCallback(() => {
    setSize((prev) => prev + 1).catch((e) => console.log(e));
  }, []);

  return { cardsToDisplay, onClickHandler };
};

export default useViewMoreFetching;
